import { Component, ViewChild } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User } from '../../../providers/';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, OvertimeProvider, ApiMyRadiant} from '../../../providers/';
import { Utility } from '../../../providers/resources/utility';
import { Calendar } from '@ionic-native/calendar';

@Component({
  selector: 'presensi-plan-overtime',
  templateUrl: 'page.html'
})
export class PlanOvertime {
  berita:any = '';
  loading : any;
  isLogin : any = 0;
  data = {
    date: null,
    daysInThisMonth: null,
    daysInLastMonth: null,
    daysInNextMonth: null,
    monthNames: ["January","February","March","April","May","June","July",
    "August","September","October","November","December"],
    currentMonth: null,
    currentYear: null,
    currentDate: null,
  };
  eventList: any;
  selectedEvent: any;
  isSelected: any;
  event = { title: "", location: "", message: "", startDate: "", endDate: "" };
  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    public calendar       : Calendar
  ) {
    this.data.date = new Date();
    this.getDaysOfMonth();
    this.loadEventThisMonth();
  }

  loadEventThisMonth() {
    this.eventList = new Array();
    var startDate = new Date(this.data.date.getFullYear(), this.data.date.getMonth(), 1);
    var endDate = new Date(this.data.date.getFullYear(), this.data.date.getMonth()+1, 0);
    //disini load ke database kemudian di save ke eventlist 
    this.eventList = [
      {"calendar_id":"5","id":"3","event_id":"40","title":"Diwali/Deepavali","startDate":"2019-10-25","endDate":"2019-10-25","eventLocation":"","allDay":1,"hourOvertime":3,"date":"2019-10-25"},
    ];    
  }

  checkEvent(day) {
    var hasEvent = false;
    var date = this.data.date.getFullYear()+"-"+(this.data.date.getMonth()+1)+"-"+day;
    // var thisDate2 = this.data.date.getFullYear()+"-"+(this.data.date.getMonth()+1)+"-"+day;
    this.eventList.forEach(event => {
      if(date == event.date) {
        hasEvent = true;
      }
    });
    return hasEvent;
  }

  selectDate(day) {
    this.isSelected = false;
    this.selectedEvent = new Array();
    var thisDate1 = this.data.date.getFullYear()+"-"+(this.data.date.getMonth()+1)+"-"+day;
    var thisDate2 = this.data.date.getFullYear()+"-"+(this.data.date.getMonth()+1)+"-"+day;
    this.eventList.forEach(event => {
      if(((event.startDate >= thisDate1) && (event.startDate <= thisDate2)) || ((event.endDate >= thisDate1) && (event.endDate <= thisDate2))) {
        this.isSelected = true;
        this.selectedEvent.push(event);
      }
    });
  }

  getDaysOfMonth() {
    this.data.daysInThisMonth = new Array();
    this.data.daysInLastMonth = new Array();
    this.data.daysInNextMonth = new Array();
    this.data.currentMonth = this.data.monthNames[this.data.date.getMonth()];
    this.data.currentYear = this.data.date.getFullYear();
    if(this.data.date.getMonth() === new Date().getMonth()) {
      this.data.currentDate = new Date().getDate();
    } else {
      this.data.currentDate = 999;
    }
  
    let firstDayThisMonth = new Date(this.data.date.getFullYear(), this.data.date.getMonth(), 1).getDay();
    let prevNumOfDays = new Date(this.data.date.getFullYear(), this.data.date.getMonth(), 0).getDate();
    for(let i = prevNumOfDays-(firstDayThisMonth-1); i <= prevNumOfDays; i++) {
      this.data.daysInLastMonth.push(i);
    }
  
    let thisNumOfDays = new Date(this.data.date.getFullYear(), this.data.date.getMonth()+1, 0).getDate();
    for (let i = 0; i < thisNumOfDays; i++) {
      this.data.daysInThisMonth.push(i+1);
    }
  
    let lastDayThisMonth = new Date(this.data.date.getFullYear(), this.data.date.getMonth()+1, 0).getDay();
    let nextNumOfDays = new Date(this.data.date.getFullYear(), this.data.date.getMonth()+2, 0).getDate();
    for (let i = 0; i < (6-lastDayThisMonth); i++) {
      this.data.daysInNextMonth.push(i+1);
    }
    let totalDays = this.data.daysInLastMonth.length+this.data.daysInThisMonth.length+this.data.daysInNextMonth.length;
    if(totalDays<32) {
      for(let i = (7-lastDayThisMonth); i < ((7-lastDayThisMonth)+7); i++) {
        this.data.daysInNextMonth.push(i);
      }
    }
  }

  goToLastMonth() {
    this.data.date = new Date(this.data.date.getFullYear(), this.data.date.getMonth(), 0);
    this.getDaysOfMonth();
  }

  goToNextMonth() {
    this.data.date = new Date(this.data.date.getFullYear(), this.data.date.getMonth()+2, 0);
    this.getDaysOfMonth();
  }

  getHourDayOvertime(day){
    let out =  '0';
    var date = this.data.date.getFullYear()+"-"+(this.data.date.getMonth()+1)+"-"+day;
    this.eventList.forEach(event => {
      if(date == event.date) {
        out =  event.hourOvertime;
      }
    });
    return out;
  }

}



// WEBPACK FOOTER //
// ./src/pages/presensi/plan_overtime/page.ts